export * from "./core-wo-model";

// localization
import "./chunks/localization";

export * from "./knockout-ui-model";
